import React from 'react';
import Logo from './Logo';
import useStallRecovery from '../hooks/useStallRecovery';

// A loading screen with self-healing: if it's still showing after the watchdog
// window (auth never settled, connection dead after sleep), it first tries a
// guarded automatic reload, and only shows a manual Reload button if that was
// suppressed (offline, or one was just attempted). No spinner without an exit.
export default function LoadingScreen({ message = 'Loading…', timeoutMs = 7000 }) {
  const showReload = useStallRecovery(true, timeoutMs);

  return (
    <div className="loading-page">
      <Logo variant="icon" width={48} />
      <p>{message}</p>
      {showReload && (
        <button type="button" className="btn btn-primary" style={{ marginTop: 16 }}
          onClick={() => window.location.reload()}>
          Reload
        </button>
      )}
    </div>
  );
}
